import { useActiveClassroom } from '../context/ActiveClassroomProvider.js';
import { KioskToggle } from '../kiosk/index.js';

/**
 * Floating bottom-right cluster that only appears once a classroom is
 * live. Today this is just the kiosk fullscreen toggle. Search moved
 * into the bottom MmPageNav (next to Home) so it's a regular page
 * rather than a one-off floating overlay.
 *
 * Hidden in hub / detail mode where the settings cog used to live —
 * those settings now live on the hub's Settings tab and on the
 * classroom-detail General tab.
 */
export function LiveMenuBox() {
  const { active } = useActiveClassroom();
  if (!active) return null;
  return (
    <nav className="menu-box" data-testid="menu-box">
      <KioskToggle />
    </nav>
  );
}
